import { useEffect, useState } from "react";
import { qrAgenzieApi } from "@/api/qrAgenzie";

/** Voce «QR Self Service Clienti»: solo per il titolare (`enabled` = ruolo affiliato) e solo
 * se il QR dell'agenzia è acceso. Su errore la voce resta nascosta. */
export function useQrAgenziaAttivo(enabled: boolean): boolean {
  const [attivo, setAttivo] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    qrAgenzieApi.stato()
      .then((s) => { if (alive) setAttivo(s.attivo); })
      .catch(() => { /* voce invisibile su errore */ });
    return () => { alive = false; };
  }, [enabled]);
  return attivo;
}
